<template>
  <div class="alloy-compare-radar">
    <apexchart ref="myChart" type="radar" height="800" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { primaryColors, secondaryColors } from "@/utils/color.js";
export default {
  name: "AlloyCompareBar",
  components: {
    apexchart: VueApexCharts,
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          height: 900,
          type: "radar",
          dropShadow: {
            enabled: true,
            blur: 1,
            left: 1,
            top: 1,
          },
        },
        tooltip: {
          enabled: true,
          x: {
            show: true,
          },
        },
        stroke: {
          width: 2,
          dashArray: this.series.map((item) => (item.name == "Predicted" ? 4 : 0)),
        },
        fill: {
          opacity: 0.2,
        },
        legend: {
          showForSingleSeries: true,
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          floating: false,
          fontFamily: "Inter",
          labels: {
            colors: [this.$vuetify.theme.isDark ? "#EBEAFA" : "#070707"],
          },
          fontSize: "12px",
          offsetY: 4,
          markers: {
            radius: 0,
            width: 13,
            height: 13,
            offsetY: 2,
          },
        },
        markers: {
          size: 0,
        },
        colors: Array.prototype.concat(["#0393A8"], primaryColors.dark, secondaryColors.dark).map(item => (this.$vuetify.theme.isDark? item+'70' : item )),
        plotOptions: {
          radar: {
            polygons: {
              strokeColors: this.$vuetify.theme.isDark?'#d0d0d020' :'#d0d0d050',
              fill: {
                  colors: ['#f8f8f810', '#0f0f0f10']
              }
            }
          }
        },
        
        xaxis: {
          categories: this.properties,
          labels: {
            style: {
              fontFamily: "Inter",
              fontSize: "12px",
              colors: this.$vuetify.theme.isDark ? Array(this.properties.length).fill("#EBEAFA") : Array(this.properties.length).fill("#070707"),
            },
          },
        },
        yaxis: {
          show: true,
          tickAmount: 10,
          min: 0,
          max: 1,
          labels: {
            show: true,
            formatter: (value) => {
              return Math.round(value * 100) + "%";
            },
            style: {
              fontFamily: "Inter",
              fontSize: "12px",
              colors: this.$vuetify.theme.isDark ? Array(11).fill("#EBEAFA") : Array(11).fill("#070707"),
            },
          },
        },
      };
    },
  },
  props: {
    properties: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
  },
  beforeDestroy() {
    document.querySelectorAll(".apexcharts-tooltip").forEach((node) => node.remove());
    const chart = this.$refs.myChart && this.$refs.myChart.chart;
    if (chart && typeof chart.destroy === "function") {
      chart.destroy();
    }
  },
};
</script>

<style scoped>
.alloy-compare-radar {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  margin-top: 0.5rem;
}
</style>
